/**
 * Плагин: по событию графа connection:added-to-view шлёт patch addConnection.
 * Событие эмитится при добавлении существующей catalog-связи на диаграмму.
 */
import {applyViewpointDimming} from '../viewpoint/applyViewpointDimming';

export default {
	init(modeler, context) {
		const {graph, onPatch, viewIndex} = context;
		const VIEW_INDEX = viewIndex ?? 0;

		const onViewConnectionAdded = ({connection} = {}) => {
			if (!connection?.identifier || !connection.source || !connection.target) return;
			onPatch({
				patches: [
					{
						op: 'addConnection',
						viewIndex: VIEW_INDEX,
						connection: {
							identifier: connection.identifier,
							source: connection.source,
							target: connection.target,
							relationshipRef: connection.relationshipRef,
							type: connection.type,
							accessType: connection.accessType,
							bendpoints: connection.bendpoints || [],
						},
					},
				],
			});
			applyViewpointDimming(modeler);
		};

		graph.on('connection:added-to-view', onViewConnectionAdded);

		return () => graph.off('connection:added-to-view', onViewConnectionAdded);
	},
};
